import store from "@/store/index.js";
import djsApi from "./djsApi.js";
import smCom from "../global/smCom.js";
import timeHelper from "../global/timeHelper.js";

const VEN_CLS_INFO = async obj => {
  let js = {};
  js["OPER"] = obj.oper;
  js["CHG_USER_ID"] = store.state.djsAdmin.user_id;
  js["MALL_ID"] = obj.mall_id || store.state.djsAdmin.mall_id;
  js["CLS_ID"] = obj.cls_id || "1001";
  js["P_CLS_ID"] = obj.p_cls_id;
  js["CLS_NAME"] = obj.cls_name;
  js["SALE_SHOW_YN_ID"] = obj.sale_show_yn_id;
  js["IMG_URL"] = obj.img_url;
  js["SORT_ID"] = obj.sort_id || "99";
  js["REMARK"] = obj.remark;
  js["STATE_ID"] = obj.state_id;
  let res = await djsApi.fDjsAdminApi({
    methodName: "VEN_CLS_INFO",
    js
  });
  return res;
};

const BRAND_INFO = async obj => {
  let js = {};
  js["OPER"] = obj.oper;
  js["CHG_USER_ID"] = store.state.djsAdmin.user_id;
  js["MALL_ID"] = obj.mall_id || store.state.djsAdmin.mall_id;
  js["CLS_ID"] = obj.cls_id || "1001";
  js["P_CLS_ID"] = obj.p_cls_id;
  js["CLS_NAME"] = obj.cls_name;
  js["SALE_SHOW_YN_ID"] = obj.sale_show_yn_id;
  js["IMG_URL"] = obj.img_url;
  js["SORT_ID"] = obj.sort_id || "99";
  js["REMARK"] = obj.remark;
  js["STATE_ID"] = obj.state_id;
  let res = await djsApi.fDjsAdminApi({
    methodName: "BRAND_INFO",
    js
  });
  return res;
};
// 获取菜品分类信息 PRO_CLS_INFO
const PRO_CLS_INFO = async obj => {
  let js = {};
  js["OPER"] = obj.oper;
  js["CHG_USER_ID"] = store.state.djsAdmin.user_id;
  js["MALL_ID"] = obj.mall_id || store.state.djsAdmin.mall_id;
  js["CLS_ID"] = obj.cls_id || "1001";
  js["P_CLS_ID"] = obj.p_cls_id;
  js["CLS_NAME"] = obj.cls_name;
  js["SALE_SHOW_YN_ID"] = obj.sale_show_yn_id;
  js["IMG_URL"] = obj.img_url;
  js["SORT_ID"] = obj.sort_id || "99";
  js["REMARK"] = obj.remark;
  js["STATE_ID"] = obj.state_id;
  let res = await djsApi.fDjsAdminApi({
    methodName: "PRO_CLS_INFO",
    js
  });
  return res;
};
// 获取菜品分类信息 SD_PRO_CLS_INFO
const SD_PRO_CLS_INFO = async obj => {
  let js = {};
  js["OPER"] = obj.oper;
  js["CHG_USER_ID"] = store.state.djsAdmin.user_id;
  js["MALL_ID"] = obj.mall_id || store.state.djsAdmin.mall_id;
  js["CLS_ID"] = obj.cls_id || "1001";
  js["P_CLS_ID"] = obj.p_cls_id;
  js["CLS_NAME"] = obj.cls_name;
  js["IMG_URL"] = obj.img_url;
  js["SORT_ID"] = obj.sort_id || "99";
  js["REMARK"] = obj.remark;
  js["STATE_ID"] = obj.state_id;
  let res = await djsApi.fDjsAdminApi({
    methodName: "SD_PRO_CLS_INFO",
    js
  });
  return res;
};
// 门店菜品信息 MALL_PRO_INFO

// 门店菜品信息 MALL_PRO_INFO
const MALL_PRO_INFO = async obj => {
  let js = {};
  js["OPER"] = obj.oper;
  js["CHG_USER_ID"] = store.state.djsAdmin.user_id;
  js["MALL_ID"] = obj.mall_id || store.state.djsAdmin.mall_id;

  js["SAAS_VER_ID"] = obj.saas_ver_id || (store.state.djsAdmin.saas_type_id == 'sipLs' ? 'sipDjsxls' : 'sipDjsxcy');


  js["PRO_ID"] = obj.pro_id;
  js["SPEC_NAME"] = obj.spec_name;
  js["SPEC_PYM"] = obj.spec_pym;
  js["UNIT_NAME"] = obj.unit_name;
  js["IN_PRICE"] = obj.in_price;
  js["SALE_PRICE"] = obj.sale_price;
  js["VIP_PRICE"] = obj.vip_price;
  js["LOW_SALE_PRICE"] = obj.low_sale_price;
  js["SALE_PTS_VAL"] = obj.sale_pts_val;
  js["SALE_LOW_NUM"] = obj.sale_low_num;
  js["ORD_MAX_NUM"] = obj.ord_max_num;
  js["SPEC_NUM"] = obj.spec_num;
  js["PRO_ID_EX"] = obj.pro_id_ex;
  js["CLS_ID"] = obj.cls_id;
  js["PRICE_TMP_YN_ID"] = obj.price_tmp_yn_id;
  js["SALE_YN_ID"] = obj.sale_yn_id;
  js["DIS_YN_ID"] = obj.dis_yn_id;
  js["WEIGHT_YN_ID"] = obj.weight_yn_id;

  js["TYPE_ID"] = obj.type_id || "sipPtsp";// 商品类型id：sipPtsp 普通商品、sipZhsp 组合商品、sipZdzh 自动转换
  js["PRICE_WAY_ID"] = obj.price_way_id || "sipPt"; // 计价方式id：sipPt普通、sipJz计重、sipJs计数

  js["STOCK_WAY_ID"] = obj.stock_way_id || "sipBgl"; //
  // 说明：
  // TYPE_ID传：sipZhsp
  // 关于称重：
  // 如果有勾选，PRICE_WAY_ID 传 sipJz 否则传 sipPt
  // 返回的时候，值为 sipPt 不勾选， sipJz勾选

  js["MUST_YN_ID"] = obj.must_yn_id;
  js["MUST_WAY_ID"] = obj.must_way_id;
  js["MUST_WAY_VAL"] = obj.must_way_val;
  js["PACK_FEE"] = obj.pack_fee || '0';
  js["PACK_NUM"] = obj.pack_num || '0';

  js["ONLY_PKG_YN_ID"] = obj.only_pkg_yn_id;
  js["HOT_YN_ID"] = obj.hot_yn_id;
  js["REC_YN_ID"] = obj.rec_yn_id;
  js["EXP_DAY_NUM"] = obj.exp_day_num;
  js["PRO_CRT_TIME"] = obj.pro_crt_time;
  js["ONLINE_PRICE"] = obj.online_price || 0;
  js["TAX_RATE"] = obj.tax_rate || 0;

  js["ONLINE_NAME"] = obj.online_name;
  js["ONLINE_CLS_ID"] = obj.online_cls_id;
  js["ONLINE_SORT_ID"] = obj.online_sort_id;
  js["CRTO_COMM_WAY_ID"] = obj.crto_comm_way_id;
  js["CRTO_COMM_VAL"] = obj.crto_comm_val;
  js["WAS_COMM_WAY_ID"] = obj.was_comm_way_id;
  js["WAS_COMM_VAL"] = obj.was_comm_val;
  js["SALE_COMM_WAY_ID"] = obj.sale_comm_way_id;
  js["SALE_COMM_VAL"] = obj.sale_comm_val;
  js["TIME_SALE_YN_ID"] = obj.time_sale_yn_id;
  js["TIME_SALE_WEEK_JNA"] = obj.time_sale_week_jna;
  js["TIME_SALE_TIME_JNA"] = obj.time_sale_time_jna;
  js["IMG_URL"] = obj.img_url;
  js["IMG_MD5"] = obj.img_md5 || "";
  js["SORT_ID"] = obj.sort_id || "99";
  js["REMARK"] = obj.remark;
  js["STATE_ID"] = obj.state_id;

  js["FEED_JSON"] = obj.feed_json || [];
  js["FLAV_JSON"] = obj.flav_json || [];
  js["PRO_JSON"] = obj.pro_json || [];
  js["OUT_TKT_JSON"] = obj.out_tkt_json || [];


  let res = await djsApi.fDjsAdminApi({
    methodName: "MALL_PRO_INFO",
    js
  });
  return res;
};

// 门店菜品规格信息 MALL_PRO_SPEC_INFO
const MALL_PRO_SPEC_INFO = async obj => {
  let js = {};
  js["OPER"] = obj.oper || ""; //【ADD（新增）、EDIT（修改）、DEL（删除）】
  js["CHG_USER_ID"] = store.state.djsAdmin.user_id;
  js["MALL_ID"] = obj.mall_id || store.state.djsAdmin.mall_id;
  js["SAAS_VER_ID"] = obj.saas_ver_id || (store.state.djsAdmin.saas_type_id == 'sipLs' ? 'sipDjsxls' : 'sipDjsxcy');
  js["PRO_ID"] = obj.pro_id || "";
  js["SPEC_ID"] = obj.spec_id || "";
  js["SPEC_NAME"] = obj.spec_name || "";
  js["SPEC_PYM"] = obj.spec_pym || "";
  js["UNIT_NAME"] = obj.unit_name || "";
  js["IN_PRICE"] = obj.in_price || "";
  js["SALE_PRICE"] = obj.sale_price || "";
  js["VIP_PRICE"] = obj.vip_price || "";
  js["ONLINE_PRICE"] = obj.online_price || 0;

  js["LOW_SALE_PRICE"] = obj.low_sale_price || "";
  js["SALE_PTS_VAL"] = obj.sale_pts_val || "";
  js["SALE_LOW_NUM"] = obj.sale_low_num || "";
  js["ORD_MAX_NUM"] = obj.ord_max_num || "";
  js["SPEC_NUM"] = obj.spec_num || "";
  js["CRTO_COMM_WAY_ID"] = obj.crto_comm_way_id || "";
  js["CRTO_COMM_VAL"] = obj.crto_comm_val || "";
  js["WAS_COMM_WAY_ID"] = obj.was_comm_way_id || "";
  js["WAS_COMM_VAL"] = obj.was_comm_val || "";
  js["SALE_COMM_WAY_ID"] = obj.sale_comm_way_id || "";
  js["SALE_COMM_VAL"] = obj.sale_comm_val || "";
  js["TIME_SALE_YN_ID"] = obj.time_sale_yn_id || "";
  js["TIME_SALE_WEEK_JNA"] = obj.time_sale_week_jna || "";
  js["TIME_SALE_TIME_JNA"] = obj.time_sale_time_jna || "";
  js["IMG_URL"] = obj.img_url || "";
  js["IMG_MD5"] = obj.img_md5 || "";
  js["SORT_ID"] = obj.sort_id || "99";
  js["PACK_FEE"] = obj.pack_fee || '0';
  js["PACK_NUM"] = obj.pack_num || '0';
  js["REMARK"] = obj.remark || "";
  js["STATE_ID"] = obj.state_id || "";

  let res = await djsApi.fDjsAdminApi({
    methodName: "MALL_PRO_SPEC_INFO",
    js
  });
  return res;
};
// 菜品加料信息 FEED_INFO
const FEED_INFO = async obj => {
  let js = {};
  js["OPER"] = obj.oper || ""; //【ADD（新增）、EDIT（修改）、DEL（删除）】
  js["CHG_USER_ID"] = store.state.djsAdmin.user_id;
  js["MALL_ID"] = obj.mall_id || store.state.djsAdmin.mall_id;
  js["PRO_ID"] = obj.pro_id || "";
  js["FEED_ID"] = obj.feed_id || ""; // 加料编码
  js["FEED_NAME"] = obj.feed_name || ""; // 加料名称
  js["CLS_ID"] = obj.cls_id || ""; // 所属分类编码
  js["ADD_PRICE"] = obj.add_price || "0"; // 加料加价
  js["IMG_URL"] = obj.img_url || ""; // 图片URL
  js["SORT_ID"] = obj.sort_id || "99"; // 排序号
  js["REMARK"] = obj.remark || ""; // 备注
  js["STATE_ID"] = obj.state_id || ""; // 状态id 【sipZc（正常）、sipSc（删除）】

  let res = await djsApi.fDjsAdminApi({
    methodName: "FEED_INFO",
    js
  });
  return res;
};
// 加料分类信息 FEED_CLS_INFO
const FEED_CLS_INFO = async obj => {
  let js = {};
  js["OPER"] = obj.oper || ""; //【ADD（新增）、EDIT（修改）、DEL（删除）】
  js["CHG_USER_ID"] = store.state.djsAdmin.user_id;
  js["MALL_ID"] = obj.mall_id || store.state.djsAdmin.mall_id;
  js["CLS_ID"] = obj.cls_id || ""; // 类别编码
  js["P_CLS_ID"] = obj.p_cls_id || ""; // 上级编码
  js["CLS_NAME"] = obj.cls_name || ""; // 类别名称
  js["IMG_URL"] = obj.img_url || ""; // 图片地址
  js["SORT_ID"] = obj.sort_id || "99"; // 排序号
  js["REMARK"] = obj.remark || ""; // 备注
  js["STATE_ID"] = obj.state_id || ""; // 状态id 【sipZc（正常）、sipSc（删除）】

  let res = await djsApi.fDjsAdminApi({
    methodName: "FEED_CLS_INFO",
    js
  });
  return res;
};
// 菜品加料信息 PRO_FEED_INFO
const PRO_FEED_INFO = async obj => {
  let js = {};
  js["OPER"] = obj.oper || ""; //【ADD（新增）、EDIT（修改）、DEL（删除）】
  js["CHG_USER_ID"] = store.state.djsAdmin.user_id;
  js["MALL_ID"] = obj.mall_id || store.state.djsAdmin.mall_id;
  js["PRO_ID"] = obj.pro_id || "";
  js["FEED_ID_JNA"] = obj.feed_id_jna || []; // 加料编码数组
  js["FEED_ID"] = obj.feed_id || ""; // 加料编码
  js["AUTO_ADD_YN_ID"] = obj.auto_add_yn_id || ""; // 自动新增id 【sipY（是）、sipN（否）】
  js["SORT_ID"] = obj.sort_id || "99"; // 排序号
  js["REMARK"] = obj.remark || ""; // 备注

  let res = await djsApi.fDjsAdminApi({
    methodName: "PRO_FEED_INFO",
    js
  });
  return res;
};

// 做法分类信息 FLAV_CLS_INFO
const FLAV_CLS_INFO = async obj => {
  let js = {};
  js["OPER"] = obj.oper || ""; //【ADD（新增）、EDIT（修改）、DEL（删除）】
  js["CHG_USER_ID"] = store.state.djsAdmin.user_id;
  js["MALL_ID"] = obj.mall_id || store.state.djsAdmin.mall_id;
  js["CLS_ID"] = obj.cls_id || ""; // 类别编码
  js["P_CLS_ID"] = obj.p_cls_id || ""; // 上级编码
  js["CLS_NAME"] = obj.cls_name || ""; // 类别名称
  js["IMG_URL"] = obj.img_url || ""; // 图片地址
  js["SORT_ID"] = obj.sort_id || "99"; // 排序号
  js["REMARK"] = obj.remark || ""; // 备注
  js["STATE_ID"] = obj.state_id || ""; // 状态id 【sipZc（正常）、sipSc（删除）】

  let res = await djsApi.fDjsAdminApi({
    methodName: "FLAV_CLS_INFO",
    js
  });
  return res;
};

// 菜品做法信息 PRO_FLAV_INFO
const PRO_FLAV_INFO = async obj => {
  let js = {};
  js["OPER"] = obj.oper || ""; //【ADD（新增）、EDIT（修改）、DEL（删除）】
  js["CHG_USER_ID"] = store.state.djsAdmin.user_id;
  js["MALL_ID"] = obj.mall_id || store.state.djsAdmin.mall_id;
  js["PRO_ID"] = obj.pro_id || "";
  js["FLAV_ID_JNA"] = obj.flav_id_jna || []; // 做法编码数组
  js["FLAV_ID"] = obj.flav_id || ""; // 做法编码
  js["AUTO_ADD_YN_ID"] = obj.auto_add_yn_id || ""; // 自动新增id 【sipY（是）、sipN（否）】
  js["SORT_ID"] = obj.sort_id || "99"; // 排序号
  js["REMARK"] = obj.remark || ""; // 备注

  let res = await djsApi.fDjsAdminApi({
    methodName: "PRO_FLAV_INFO",
    js
  });
  return res;
};
// 菜品做法信息 FLAV_INFO
const FLAV_INFO = async obj => {
  let js = {};
  js["OPER"] = obj.oper || ""; //【ADD（新增）、EDIT（修改）、DEL（删除）】
  js["CHG_USER_ID"] = store.state.djsAdmin.user_id;
  js["MALL_ID"] = obj.mall_id || store.state.djsAdmin.mall_id;
  js["PRO_ID"] = obj.pro_id || "";
  js["FLAV_ID"] = obj.flav_id || ""; // 做法编码
  js["FLAV_NAME"] = obj.flav_name || ""; // 做法名称
  js["CLS_ID"] = obj.cls_id || ""; // 所属分类编码
  js["ADD_PRICE"] = obj.add_price || "0"; // 做法加价
  js["IMG_URL"] = obj.img_url || ""; // 图片URL
  js["SORT_ID"] = obj.sort_id || "99"; // 排序号
  js["REMARK"] = obj.remark || ""; // 备注
  js["STATE_ID"] = obj.state_id || ""; // 状态id 【sipZc（正常）、sipSc（删除）】

  let res = await djsApi.fDjsAdminApi({
    methodName: "FLAV_INFO",
    js
  });
  return res;
};

// 门店分类信息 MALL_CLS_INFO
const MALL_CLS_INFO = async obj => {
  let js = {};
  js["OPER"] = obj.oper || ""; //【ADD（新增）、EDIT（修改）、DEL（删除）】
  js["CHG_USER_ID"] = store.state.djsAdmin.user_id;
  js["MALL_ID"] = obj.mall_id || store.state.djsAdmin.mall_id;
  js["CLS_ID"] = obj.cls_id || ""; // 类别编码
  js["P_CLS_ID"] = obj.p_cls_id || ""; // 上级编码
  js["CLS_NAME"] = obj.cls_name || ""; // 类别名称
  js["IMG_URL"] = obj.img_url || ""; // 图片地址
  js["SORT_ID"] = obj.sort_id || "99"; // 排序号
  js["REMARK"] = obj.remark || ""; // 备注
  js["STATE_ID"] = obj.state_id || ""; // 状态id 【sipZc（正常）、sipSc（删除）】

  let res = await djsApi.fDjsAdminApi({
    methodName: "MALL_CLS_INFO",
    js
  });
  return res;
};
//  门店信息 MALL_INFO
const MALL_INFO = async obj => {
  let js = {};
  js["OPER"] = obj.oper || ""; //【ADD（新增）、EDIT（修改）、DEL（删除）】
  js["CHG_USER_ID"] = store.state.djsAdmin.user_id;
  js["CRT_MALL_ID"] = obj.crt_mall_id || store.state.djsAdmin.mall_id;
  js["MALL_ID"] = obj.mall_id || store.state.djsAdmin.mall_id;
  js["CLS_ID"] = obj.cls_id || "";
  js["MALL_NAME"] = obj.mall_name || "";
  js["MALL_TEL"] = obj.mall_tel || "";
  js["CP_NAME"] = obj.cp_name || "";
  js["CP_PHONE"] = obj.cp_phone || "";
  js["CO_PHONE"] = obj.co_phone || "";
  js["MALL_AREA"] = obj.mall_area || "";
  js["BUS_TYPE_ID"] = obj.bus_type_id || "";
  js["PROV_CODE"] = obj.prov_code || "";
  js["CITY_CODE"] = obj.city_code || "";
  js["AREA_CODE"] = obj.area_code || "";
  js["ADR_DETAIL"] = obj.adr_detail || "";
  js["ADR_LON"] = obj.adr_lon || "";
  js["ADR_LAT"] = obj.adr_lat || "";
  js["IMG_URL"] = obj.img_url || "";
  js["SORT_ID"] = obj.sort_id || "99";
  js["REMARK"] = obj.remark || "";
  js["STATE_ID"] = obj.state_id || "";
  js["ONLINE_DSP_YN_ID"] = obj.online_dsp_yn_id || "";
  js["ONLINE_SALE_YN_ID"] = obj.online_sale_yn_id || "";
  js["ONLINE_BUS_START_TIME"] = obj.online_bus_start_time || "";
  js["ONLINE_BUS_OVER_TIME"] = obj.online_bus_over_time || "";
  js["ONLINE_MALL_REMARK"] = obj.online_mall_remark || "";
  js["ONLINE_MO_AMT"] = obj.online_mo_amt || "";
  js["ONLINE_SD_REMARK"] = obj.online_sd_remark || "";
  js["ONLINE_SD_DIST"] = obj.online_sd_dist || "";
  js["ONLINE_SD_FEE"] = obj.online_sd_fee || "";
  js["ONLINE_SD_FEE_AMT"] = obj.online_sd_fee_amt || "";

  let res = await djsApi.fDjsAdminApi({
    methodName: "MALL_INFO",
    js
  });
  return res;
};
// 餐桌区域信息
const DTABLE_CLS_INFO = async obj => {
  let js = {};
  js["OPER"] = obj.oper || ""; //【ADD（新增）、EDIT（修改）、DEL（删除）】
  js["CHG_USER_ID"] = store.state.djsAdmin.user_id;
  js["MALL_ID"] = obj.mall_id || store.state.djsAdmin.mall_id;
  js["CLS_ID"] = obj.cls_id || ""; // 类别编码
  js["P_CLS_ID"] = obj.p_cls_id || ""; // 上级编码
  js["CLS_NAME"] = obj.cls_name || ""; // 类别名称
  js["IMG_URL"] = obj.img_url || ""; // 图片地址
  js["SORT_ID"] = obj.sort_id || "99"; // 排序号
  js["REMARK"] = obj.remark || ""; // 备注
  js["STATE_ID"] = obj.state_id || ""; // 状态id 【sipZc（正常）、sipSc（删除）】

  let res = await djsApi.fDjsAdminApi({
    methodName: "DTABLE_CLS_INFO",
    js
  });
  return res;
};

// 餐桌信息 DTABLE_INFO
const DTABLE_INFO = async obj => {
  let js = {};
  js["OPER"] = obj.oper || ""; //【ADD（新增）、EDIT（修改）、DEL（删除）】
  js["CHG_USER_ID"] = store.state.djsAdmin.user_id;
  js["MALL_ID"] = obj.mall_id || store.state.djsAdmin.mall_id;
  js["DTABLE_ID"] = obj.dtable_id || ""; // 餐桌编码
  js["DTABLE_NAME"] = obj.dtable_name || ""; // 餐桌名称
  js["CLS_ID"] = obj.cls_id || ""; // 餐桌所属区域编码
  js["PERSON_NUM"] = obj.person_num || ""; // 可坐人数
  js["MIN_CHAGE"] = obj.min_chage || ""; // 最低消费
  js["QR_URL"] = obj.qr_url || ""; // 桌台码
  js["SORT_ID"] = obj.sort_id || "99"; // 排序号
  js["REMARK"] = obj.remark || ""; // 备注
  js["STATE_ID"] = obj.state_id || ""; // 状态id 【sipZc（正常）、sipSc（删除）】

  let res = await djsApi.fDjsAdminApi({
    methodName: "DTABLE_INFO",
    js
  });
  return res;
};

// 餐桌区域信息
const USER_CLS_INFO = async obj => {
  let js = {};
  js["OPER"] = obj.oper || ""; //【ADD（新增）、EDIT（修改）、DEL（删除）】
  js["CHG_USER_ID"] = store.state.djsAdmin.user_id;
  js["MALL_ID"] = obj.mall_id || store.state.djsAdmin.mall_id;
  js["CLS_ID"] = obj.cls_id || ""; // 类别编码
  js["P_CLS_ID"] = obj.p_cls_id || ""; // 上级编码
  js["CLS_NAME"] = obj.cls_name || ""; // 类别名称
  js["IMG_URL"] = obj.img_url || ""; // 图片地址
  js["SORT_ID"] = obj.sort_id || "99"; // 排序号
  js["REMARK"] = obj.remark || ""; // 备注
  js["STATE_ID"] = obj.state_id || ""; // 状态id 【sipZc（正常）、sipSc（删除）】
  js["AUTH_JNA"] = obj.auth_jna || ""; // 菜单权限数组

  let res = await djsApi.fDjsAdminApi({
    methodName: "USER_CLS_INFO",
    js
  });
  return res;
};

// 员工信息 USER_INFO
const USER_INFO = async obj => {
  let js = {};
  js["OPER"] = obj.oper || ""; //【ADD（新增）、EDIT（修改）、DEL（删除）】
  js["CHG_USER_ID"] = store.state.djsAdmin.user_id;
  js["CHG_MALL_ID"] = store.state.djsAdmin.mall_id;
  js["MALL_ID"] = obj.mall_id || store.state.djsAdmin.mall_id;
  js["USER_ID"] = obj.user_id || "";
  js["USER_NAME"] = obj.user_name || "";
  js["USER_PSW"] = obj.user_psw || "";
  js["CLS_ID"] = obj.cls_id || "";
  js["SFZ_NO"] = obj.sfz_no || "";
  js["PROV_CODE"] = obj.prov_code || "";
  js["CITY_CODE"] = obj.city_code || "";
  js["AREA_CODE"] = obj.area_code || "";
  js["NOW_ADR"] = obj.now_adr || "";
  js["HOME_ADR"] = obj.home_adr || "";
  js["SEX_ID"] = obj.sex_id || "";
  js["BIR"] = obj.bir || "";
  js["EDU"] = obj.edu || "";
  js["JOB_TYPE"] = obj.job_type || "";
  js["MAX_DIS_RATE"] = obj.max_dis_rate || "";
  js["MAX_DIS_AMT"] = obj.max_dis_amt || "";
  js["PRO_MAX_DIS_RATE"] = obj.pro_max_dis_rate || "";
  js["PRO_MAX_DIS_AMT"] = obj.pro_max_dis_amt || "";
  js["COMM_WAY_ID"] = obj.comm_way_id || "";
  js["COMM_VAL"] = obj.comm_val || "";
  js["IMG_URL"] = obj.img_url || "";
  js["SORT_ID"] = obj.sort_id || "99";
  js["REMARK"] = obj.remark || "";
  js["STATE_ID"] = obj.state_id || ""; // 状态id 【sipZc（正常）、sipSc（删除）】

  let res = await djsApi.fDjsAdminApi({
    methodName: "USER_INFO",
    js
  });
  return res;
};

// 备注信息 REMARK_INFO
const REMARK_INFO = async obj => {
  let js = {};
  js["OPER"] = obj.oper || ""; //【ADD（新增）、EDIT（修改）、DEL（删除）】
  js["CHG_USER_ID"] = store.state.djsAdmin.user_id;
  js["MALL_ID"] = obj.mall_id || store.state.djsAdmin.mall_id;
  js["REMARK_ID"] = obj.remark_id || store.state.djsAdmin.mall_id;
  js["REMARK_TYPE_ID"] = obj.remark_type_id || ""; //【单品备注、整单备注、退款备注、退菜备注、打折 / 赠送备注、充值备注、开台备注】
  js["USER_ID"] = obj.user_id || store.state.djsAdmin.user_id;
  js["REMARK"] = obj.remark || ""; // 备注内容
  js["SORT_ID"] = obj.sort_id || "99";
  js["STATE_ID"] = obj.state_id || ""; // 状态id 【sipZc（正常）、sipSc（删除）】

  let res = await djsApi.fDjsAdminApi({
    methodName: "REMARK_INFO",
    js
  });
  return res;
};
// 账户信息 MALL_ACCT_INFO
const MALL_ACCT_INFO = async obj => {
  let js = {};
  js["OPER"] = obj.oper || ""; //【ADD（新增）、EDIT（修改）、DEL（删除）】
  js["CHG_USER_ID"] = store.state.djsAdmin.user_id;
  js["MALL_ID"] = obj.mall_id || store.state.djsAdmin.mall_id;
  js["ACCT_ID"] = obj.acct_id || "";
  js["ACCT_NAME"] = obj.acct_name || "";
  js["AMT_RATE"] = obj.amt_rate || "";
  js["QUICK_KEY"] = obj.quick_key || "";
  js["VR_YN_ID"] = obj.vr_yn_id || ""; //【sipY（是）、sipN（否）】
  js["ADMIN_USE_YN_ID"] = obj.admin_use_yn_id || ""; //【sipY（是）、sipN（否）】
  js["POS_USE_YN_ID"] = obj.pos_use_yn_id || ""; //【sipY（是）、sipN（否）】
  js["IMG_URL"] = obj.img_url || "";
  js["SORT_ID"] = obj.sort_id || "99";
  js["REMARK"] = obj.remark || "";
  js["STATE_ID"] = obj.state_id || ""; // 状态id 【sipZc（正常）、sipSc（删除）】

  let res = await djsApi.fDjsAdminApi({
    methodName: "MALL_ACCT_INFO",
    js
  });
  return res;
};

const MALL_COMBO_INFO = async obj => {
  let js = {};
  js["OPER"] = obj.oper || ""; //【ADD（新增）、EDIT（修改）、DEL（删除）】
  js["CHG_USER_ID"] = store.state.djsAdmin.user_id;
  js["MALL_ID"] = obj.mall_id || store.state.djsAdmin.mall_id;
  js["COMBO_ID"] = obj.combo_id || "";
  js["COMBO_NAME"] = obj.combo_name || "";
  js["COMBO_PYM"] = obj.combo_pym || "";
  js["SALE_PRICE"] = obj.sale_price || "";
  js["VIP_PRICE"] = obj.vip_price || "";
  js["SALE_PTS_VAL"] = obj.sale_pts_val || "";
  js["SALE_LOW_NUM"] = obj.sale_low_num || "";
  js["ORD_MAX_NUM"] = obj.ord_max_num || "";
  js["CRTO_COMM_WAY_ID"] = obj.crto_comm_way_id || "";
  js["CRTO_COMM_VAL"] = obj.crto_comm_val || "";
  js["WAS_COMM_WAY_ID"] = obj.was_comm_way_id || "";
  js["WAS_COMM_VAL"] = obj.was_comm_val || "";
  js["SALE_COMM_WAY_ID"] = obj.sale_comm_way_id || "";
  js["SALE_COMM_VAL"] = obj.sale_comm_val || "";
  js["MUST_JNA"] = obj.must_jna || [];
  //   【[{ "pro_id": "100001", "spec_id": "100001", "pro_num": "1" },
  // { "pro_id": "10011003", "spec_id": "1001100301", "pro_num": "2" }]      】
  js["OPT_JNA"] = obj.opt_jna || [];
  //   【[{ "pro_id": "100002", "spec_id": "100002", "pro_num": "1" },
  // { "pro_id": "10011002", "spec_id": "1001100201", "pro_num": "2" }]      】
  js["IMG_URL"] = obj.img_url || "";
  js["SORT_ID"] = obj.sort_id || "99";
  js["REMARK"] = obj.remark || "";
  js["STATE_ID"] = obj.state_id || ""; // 状态id 【sipZs（在售）、sipTs（停售）、sipSc（删除）】

  let res = await djsApi.fDjsAdminApi({
    methodName: "MALL_COMBO_INFO",
    js
  });
  return res;
};

const VIP_CLS_INFO = async obj => {
  let js = {};
  js["OPER"] = obj.oper || "";
  js["CHG_USER_ID"] = store.state.djsAdmin.user_id;
  js["MALL_ID"] = obj.mall_id || store.state.djsAdmin.mall_id;
  js["CLS_ID"] = obj.cls_id || "";
  js["P_CLS_ID"] = obj.p_cls_id || "";
  js["CLS_NAME"] = obj.cls_name || "";
  js["PRICE_WAY_ID"] = obj.price_way_id || "";
  js["VIP_DIS_RATE"] = obj.vip_dis_rate || "0";
  js["DAILY_LIMIT_YN_ID"] = obj.daily_limit_yn_id || "";
  js["DAILY_LIMIT_AMT"] = obj.daily_limit_amt || "0";
  js["VIP_PAY_DIS_YN_ID"] = obj.vip_pay_dis_yn_id || "";
  js["VIP_PAY_DIS_RATE"] = obj.vip_pay_dis_rate || "0";
  js["MALL_TYPE_ID"] = obj.mall_type_id || "";
  js["MALL_TYPE_JSON"] = obj.mall_json || "";
  js["PTS_WAY_ID"] = obj.pts_way_id || "";
  js["ORD_AMT"] = obj.ord_amt || "";
  js["ORD_GET_PTS"] = obj.ord_get_pts || "0";
  js["PTS_WAY_JSON"] = obj.pts_pro_cls || "";
  js["JF_PAY_YN_ID"] = obj.jf_pay_yn_id || "sipN";
  js["PTS_PAY_VAL"] = obj.pts_pay_val || "0";
  js["PTS_PAY_AMT"] = obj.pts_pay_amt || "0";
  js["REC_VIP_ADD_PTS_YN_ID"] = obj.rec_vip_add_pts_yn_id || "sipN";
  js["VIP_BIR_GET_DB_PTS_YN_ID"] = obj.vip_bir_get_db_pts_yn_id || "sipN";
  js["SP_PTS_YN_ID"] = obj.sp_pts_yn_id || "sipN";
  js["PTS_INT_ROUND_YN_ID"] = obj.pts_int_round_yn_id || "sipN";
  js["CHARGE_YN_ID"] = obj.charge_yn_id || "";
  js["CHARGE_AMT"] = obj.charge_amt || "0";
  js["BUYED_ACT_DAY"] = obj.buyed_act_day || "";
  js["BUYED_STOP_DAY"] = obj.buyed_stop_day || "";
  js["AUTO_UPDOWNGRADE_YN_ID"] = obj.auto_updowngrade_yn_id || "";
  js["STOP_DOWNGRADE_CLS_ID"] = obj.stop_downgrade_cls_id || "";
  js["AUTO_UPGRADE_TYPE_ID"] = obj.auto_upgrade_type_id || "";
  js["AUTO_UPGRADE_JSON"] = obj.auto_upgrade_json || "";
  js["AUTO_UPGRADE_CLS_ID"] = obj.auto_upgrade_cls_id || "";
  js["AUTO_DOWNGRADE_TYPE_ID"] = obj.auto_downgrade_type_id || "";
  js["AUTO_DOWNGRADE_JSON"] = obj.auto_downgrade_json || "";
  js["AUTO_DOWNGRADE_CLS_ID"] = obj.auto_downgrade_cls_id || "";
  js["SPECIAL_REMARK"] = obj.special_remark || "";
  js["STATE_ID"] = obj.state_id || "sipZc"; // 默认正常状态
  js["SORT_ID"] = obj.sort_id || "99";
  js["REMARK"] = obj.remark || "";
  console.log(js);
  let res = await djsApi.fDjsAdminApi({
    methodName: "VIP_CLS_INFO",
    js
  });
  return res;
};

const VIP_INFO = async obj => {
  let js = {};
  js["OPER"] = obj.oper || ""; // 操作
  js["CHG_USER_ID"] = store.state.djsAdmin.user_id; // 修改员工ID
  js["MALL_ID"] = obj.mall_id || store.state.djsAdmin.mall_id; // 登录的门店编码
  js["VIP_ID"] = obj.vip_id || ""; // m-必传-m 会员卡号
  js["VIP_NAME"] = obj.vip_name || ""; // 会员名称
  js["PYM"] = obj.pym || ""; // 拼音码
  js["VIP_PSW"] = obj.vip_psw || ""; // 会员密码
  js["PHONE"] = obj.phone || ""; // 会员手机号
  js["CARD_ID"] = obj.card_id || ""; // 实体卡号
  js["CLS_ID"] = obj.cls_id || ""; // 会员等级id
  js["SEX_ID"] = obj.sex_id || "sipSexN"; // 性别id： sipSexN男、sipSexV 女、sipSexQt 其他
  js["ID_CARD"] = obj.id_card || ""; // 身份证号码
  js["VIP_BIR_TYPE_ID"] = obj.vip_bir_type_id || "sipBirGl"; // 会员生日类别id：sipBirGl 公历、sipBirNl 农历
  js["VIP_BIR"] = obj.vip_bir || ""; // 生日
  js["COMPANY"] = obj.company || ""; // 单位名称
  js["COMPANY_ADR"] = obj.company_adr || ""; // 单位地址
  js["NOW_ADR"] = obj.now_adr || ""; // 现居住地
  js["PROV_CODE"] = obj.prov_code || ""; // 省编码
  js["CITY_CODE"] = obj.city_code || ""; // 市编码
  js["AREA_CODE"] = obj.area_code || ""; // 区编码
  js["ADR_DETAIL"] = obj.adr_detail || ""; // 详细地址ADR_DETAIL: string; // 详细地址
  js["EXP_TIME"] = obj.exp_time || ""; // 到期时间
  js["ELABEL_ID"] = obj.elabel_id || ""; // 标签id
  js["ELABEL_LNG"] = obj.elabel_lng || ""; // 标签名称
  js["OA_TYPE_ID"] = obj.oa_type_id || ""; // 赊账类别id：sipkq 开启 sipGb 关闭
  js["NOW_AMT"] = obj.now_amt || ""; // 余额
  js["NOW_PTS"] = obj.now_pts || "0"; // 积分
  js["PRE_AMT"] = obj.pre_amt || "0"; // 押金
  js["CL_AMT"] = obj.cl_amt || "0"; // 授信额度
  js["LIMIT_USER_TIME"] = obj.limit_user_time || "9999"; // 限用次数
  js["WX_OPEN_ID"] = obj.wx_open_id || "";
  js["WX_MIN_OPEN_ID"] = obj.wx_min_open_id || "";
  js["ALI_OPEN_ID"] = obj.ali_open_id || "";
  js["ALI_MIN_OPEN_ID"] = obj.ali_min_open_id || "";
  js['REC_VIP_ID'] = obj.rec_vip_id || '' // 推荐会员id
  js["IMG_URL"] = obj.img_url || "";
  js["STATE_ID"] = obj.state_id || "sipZc"; // 默认正常状态
  js["DEF_YN_ID"] = obj.def_yn_id || ""; // 是否默认id
  js["SMS_SEND_ID"] = obj.sms_send_id || ""; // 短信通知id：sipKq 开启 sipGb 关闭
  js["SORT_ID"] = obj.sort_id || "99";
  js["REMARK"] = obj.remark || "";

  let res = await djsApi.fDjsAdminApi({
    methodName: "VIP_INFO",
    js
  });
  return res;
};
const CRT_SAAS_DB = async obj => {
  let js = {};
  js['OPER'] = 'CRT_DB'
  js['P_MCH_ID'] = obj.p_mch_id
  js['MCH_ID'] = obj.mch_id
  js['MALL_ID'] = obj.mall_id || '10011001'
  // js['SAAS_TYPE_ID'] = obj.saas_type_id || 'sipCy'// saas软件类型  零售sipLs  餐饮sipCy
  // js['SAAS_VER_ID'] = obj.saas_ver_id || 'sipCyv8' //尚米零售v8  siplssv8 尚米餐饮v8 sipcyv8

  let res = await djsApi.fSmCloudAdminApi({
    methodName: 'CRT_SAAS_DB',
    js,
    mchId: '320250710',
    userId: '320250710',
    signType: 'MD5',
    sOrgAk: 'tucy6kfCCANmOKVvi2K3KsovLeN3klACkgUY4lSb0bHSYxgUoQhZ2wPhysjKfKYf',
    sOrgSk: "Hewuyrmli9JGRu9RLxOUMEcnKXK4xEyV4A5EYRSimxmw8Y06qYSvvKcNgzaKlJJk"
  })
  return res;
};






export default {
  VEN_CLS_INFO, //供应商分类信息
  PRO_CLS_INFO, // 菜品分类信息
  SD_PRO_CLS_INFO,
  MALL_PRO_INFO, // 门店菜品信息
  MALL_PRO_SPEC_INFO, // 门店菜品规格信息
  PRO_FEED_INFO, // 菜品加料信息
  FEED_INFO, // 加料信息
  FEED_CLS_INFO, // 加料分类信息
  FLAV_CLS_INFO, // 做法分类信息
  PRO_FLAV_INFO, // 菜品做法信息
  FLAV_INFO, // 菜品做法信息
  MALL_INFO, // 门店信息
  MALL_CLS_INFO, // 门店分类信息
  DTABLE_CLS_INFO, // 餐桌区域信息
  DTABLE_INFO, // 餐桌信息
  USER_CLS_INFO, // 员工分类信息
  USER_INFO, // 员工信息
  REMARK_INFO, // 备注信息
  MALL_ACCT_INFO, // 账户信息
  MALL_COMBO_INFO, // 套餐信息
  VIP_CLS_INFO,
  VIP_INFO,
  CRT_SAAS_DB,
  BRAND_INFO, // 品牌信息
};



//////////////////
// WEBPACK FOOTER
// ./common/api/adminApi.js
// module id = null
// module chunks = 